import { EntityStatus, IdentityTypeCode } from '@verifime/utils';
import IdentityFilterPanel from './internal/filters/IdentityFilterPanel';
import SearchCriteria, { TSearchCriteriaProps } from './internal/SearchCriteria';
import { IdentityFilter } from './types';

export type TIdentitySearchCriteria = Pick<
  TSearchCriteriaProps<IdentityFilter>,
  'onSearch' | 'onCriteriaChanged' | 'placeholder'
>;

export default function IdentitySearchCriteria({ placeholder, ...props }: TIdentitySearchCriteria) {
  const createEmptyCriteria = () => ({
    searchText: '',
    filters: {
      status: EntityStatus.Verified,
      type: IdentityTypeCode.Individual_Domestic,
    },
  });

  return (
    <SearchCriteria<IdentityFilter>
      {...props}
      placeholder={placeholder}
      createEmptyCriteria={createEmptyCriteria}
      FilterPanel={IdentityFilterPanel}
      filterLabels={{
        status: 'Status',
        type: 'Type',
      }}
    />
  );
}
